import Footer from './Footer';
import { withUserAndBaseData } from '../../lib';

export default withUserAndBaseData(Footer);
